import { memo } from "react";
import {
    GridToolbarContainer,
    GridToolbarDensitySelector,
    GridToolbarQuickFilter,
} from "@mui/x-data-grid";

const ChildTransactionsToolbar = () => (
    <GridToolbarContainer
        sx={{
            gap: 10
        }}
    >
        <GridToolbarDensitySelector />
        <GridToolbarQuickFilter />
    </GridToolbarContainer>
);

export default memo(ChildTransactionsToolbar);
